<template>
    <div class="paddingSpace">
      <b-container>
        <b-row class="TitleArea">
            <b-col sm="12" lg="6">
                <h1 class="heading extraPad">Order of Merit</h1>
            </b-col>
            <b-col  sm="12" lg="6" class="above769">
                <b-link to="/stats" class="allNewsLink">
                    <button class="Allbuttons">
                        See Full Rankings
                    </button>
                </b-link>
            </b-col>
        </b-row>
        <div class="above769">
          <vueper-slides
            class="no-shadow"
            :visible-slides="3"
            :gap="2"
            :bullets="false"
            :autoplay="true"
            :duration="3000"
            :slide-ratio="1 / 4"
            :infinite="true"
            :dragging-distance="70">
            <template #arrow-left>
              <img class="arrowSize leftArrow" src="https://ams3.digitaloceanspaces.com/ocs-sport/mena/2026/01/left-arrow.png">
            </template>

            <template #arrow-right>
              <img class="arrowSize rightArrow" src="https://ams3.digitaloceanspaces.com/ocs-sport/mena/2026/01/right-arrow.png">
            </template>
            <vueper-slide v-for="(slide, i) in slides" :key="i">
              <template #content>
                <template v-if="slide.image == 'Y'">
                  <div class="oomImage" v-bind:style="{ 'background-image': 'url(' + 'https://tms-images.ams3.cdn.digitaloceanspaces.com/mena/media/photos/' + slide.playerno +'.jpg' + ')' }">
                  </div>
                </template>
                <template v-else>
                  <div class="oomImage" v-bind:style="{ 'background-image': 'url(' + 'https://ams3.digitaloceanspaces.com/ocs-sport/mena/2026/01/DummyProfile.png' + ')' }">
                  </div>
                </template>
                <div class="oomSliderPad">
                  <div class="posCenter">
                      <span class="posPosition">{{slide.pos}}</span>
                  </div>
                    <p class="slideName">
                    {{slide.forename}}
                    <br>
                    {{slide.surname}}
                    </p>
                  <b-row> 
                    <b-col>
                      <span class="oomSliderTitle">Nationality</span>
                    </b-col>
                    <b-col>
                      <span class="oomSliderDetails">
                        <img
                        :class="flag"
                        :src="(config.VUE_APP_FLAG_URL + slide.nationality) | lowercase"
                        />
                      </span>
                    </b-col>
                  </b-row>
                  <hr class="lineBreakLine">
                  <b-row>
                    <b-col>
                      <span class="oomSliderTitle">Points</span>
                    </b-col>
                    <b-col>
                      <span class="oomSliderDetails">{{slide.oom_value}}</span>
                    </b-col>
                  </b-row>
                  <hr class="lineBreakLine">
                  <b-row>
                    <b-col>
                      <span class="oomSliderTitle">Tournament</span>
                    </b-col>
                    <b-col>
                      <span class="oomSliderDetails">{{slide.tournaments_played}}</span>
                    </b-col>
                  </b-row>
                </div>
              </template>
            </vueper-slide>
          </vueper-slides>
        </div>
        <div class="below769">
          <vueper-slides
            :touchable="true"
            class="no-shadow"
            :visible-slides="1"
            :gap="2"
            :bullets="false"
            :autoplay="true"
            :duration="3000"
            :slide-ratio="1 / 4"
            :infinite="true"
            :dragging-distance="70">
            <vueper-slide v-for="(slide, i) in slides" :key="i">
              <template #content>
                <template v-if="slide.image == 'Y'">
                  <div class="oomImage" v-bind:style="{ 'background-image': 'url(' + 'https://tms-images.ams3.cdn.digitaloceanspaces.com/mena/media/photos/' + slide.playerno +'.jpg' + ')' }">
                  </div>
                </template>
                <template v-else>
                  <div class="oomImage" v-bind:style="{ 'background-image': 'url(' + 'https://ams3.digitaloceanspaces.com/ocs-sport/mena/2026/01/DummyProfile.png' + ')' }">
                  </div>
                </template>
                <div class="oomSliderPad">
                  <div class="posCenter">
                      <span class="posPosition">{{slide.pos}}</span>
                  </div>
                    <p class="slideName">
                    {{slide.forename}}
                    <br>
                    {{slide.surname}}
                    </p>
                  <b-row> 
                    <b-col>
                      <span class="oomSliderTitle">Nationality</span>
                    </b-col>
                    <b-col>
                      <span class="oomSliderDetails">
                        <img
                        :class="flag"
                        :src="(config.VUE_APP_FLAG_URL + slide.nationality) | lowercase"
                        />
                      </span>
                    </b-col>
                  </b-row>
                  <hr class="lineBreakLine">
                  <b-row>
                    <b-col>
                      <span class="oomSliderTitle">Points</span>
                    </b-col>
                    <b-col>
                      <span class="oomSliderDetails">{{slide.oom_value}}</span>
                    </b-col>
                  </b-row>
                  <hr class="lineBreakLine">
                  <b-row>
                    <b-col>
                      <span class="oomSliderTitle">Tournament</span>
                    </b-col>
                    <b-col>
                      <span class="oomSliderDetails">{{slide.tournaments_played}}</span>
                    </b-col>
                  </b-row>
                </div>
              </template>
            </vueper-slide>
          </vueper-slides>
          <div class="mobFulRank">
              <b-link to="/stats" class="allNewsLink">
                  <button class="Allbuttons">
                      See Full Rankings
                  </button>
              </b-link>
          </div>
        </div>
        <!-- <carousel-3d :autoplay="true" :autoplay-timeout="5000" :display="5" :controls-visible="true" :disable3d="true" :space="380">
            <slide v-for="(slide, i) in slides" :index="i" :key="i" >
              <template v-if="slide.image == 'Y'">
                <div class="oomImage" v-bind:style="{ 'background-image': 'url(' + 'https://tms-images.ams3.cdn.digitaloceanspaces.com/mena/media/photos/' + slide.playerno +'.jpg' + ')' }">
                </div>
              </template>
              <template v-else>
                <div class="oomImage" v-bind:style="{ 'background-image': 'url(' + 'https://ams3.digitaloceanspaces.com/ocs-sport/tartanprotour/2025/02/dummy-image.jpg' + ')' }">
                </div>
              </template>
              <div class="oomSliderPad">
                <div class="posCenter">
                    <span class="posPosition">{{slide.pos}}</span>
                </div>
                  <p class="slideName">
                  {{slide.forename}}
                  <br>
                  {{slide.surname}}
                  </p>
                <b-row> 
                  <b-col>
                    <span class="oomSliderTitle">Nationality</span>
                  </b-col>
                  <b-col>
                    <span class="oomSliderDetails">
                      <img
                      :class="flag"
                      :src="(config.VUE_APP_FLAG_URL + slide.nationality) | lowercase"
                      />
                    </span>
                  </b-col>
                </b-row>
                <hr class="lineBreakLine">
                <b-row>
                  <b-col>
                    <span class="oomSliderTitle">Points</span>
                  </b-col>
                  <b-col>
                    <span class="oomSliderDetails">{{slide.oom_value}}</span>
                  </b-col>
                </b-row>
                <hr class="lineBreakLine">
                <b-row>
                  <b-col>
                    <span class="oomSliderTitle">Tournament</span>
                  </b-col>
                  <b-col>
                    <span class="oomSliderDetails">{{slide.tournaments_played}}</span>
                  </b-col>
                </b-row>
              </div>
            </slide>
        </carousel-3d> -->
      </b-container>
    </div>
</template>
<script>
import apiCall from "@/services/api.js";
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
// import { Carousel3d, Slide } from 'vue-carousel-3d';
export default {
  name: "OOM Slider Homepage",
  props: ["Year", 'config'],
    components: {
        // Carousel3d,
        // Slide
        VueperSlides, VueperSlide
    },
  data() {
    return {
      slides: 10,
      fields: [
        { key: "pos", label: "Pos" , class: "posnum"},
        { key: "name", label: "Name" },
        { key: "nationality", label: "Nat" },
        { key: "oom_value", label: "Points" },
        { key: "tournaments_played", label: "Tourns" }
      ],
      currentOom: [],
      previousOom: [],
      year: parseInt(this.Year) - 1,
      flag: "flag",
      pPage:4,
      oomData: [],
    };
  },
  methods:{
    upDown(){
      if (this.pPage === 4)
      this.pPage = 10
      else if (this.pPage === 10)
      this.pPage = 4
    }
  },
  computed:{
    ooms:function (){
      if (this.currentOom !== null)
      return this.currentOom
      else return this.previousOom
    }
  },
  filters: {
    lowercase: function(value) {
      if (!value) {
        return "";
      }

      return value.toLowerCase() + ".svg";
    }
  },
  async mounted() {
    try {
      var stat = "-ooms-oom-" + process.env.VUE_APP_OOM
      // First call, await for call to return
      let second_call = await apiCall.stat(this.Year, stat);
      this.oomData = second_call.data;
      if (Object.keys(this.oomData).length === 0) {
        let third_call = await apiCall.stat(this.year, stat);
        this.slides = third_call.data.oom.oom_entry.slice(0,10);
        let string = JSON.stringify(this.slides)
        localStorage.setItem("oom", string)
        this.oomData = third_call.data;
      } else {
        this.slides = second_call.data.oom.oom_entry.slice(0,10);
        let string = JSON.stringify(this.slides)
        localStorage.setItem("oom", string)
      }
      this.loading = false;
    } catch (error) {
      console.log("error in await calls");
      console.log(error);
      throw error;
    }
  }
};
</script>

<style scoped>
a.allNewsLink {
  text-decoration: none!important;
}
.mobFulRank {
  position: relative;
  top: -18px;
}
::v-deep button.vueperslides__arrow.vueperslides__arrow--prev {
  left: -5.5em;
}
::v-deep button.vueperslides__arrow.vueperslides__arrow--next {
  right: -5.5em;
}
.arrowSize {
  width: 80px;
}
img.arrowSize.leftArrow {
}
img.arrowSize.rightArrow {
}
.vueperslides--rtl .vueperslides__arrows--outside .vueperslides__arrow--prev, .vueperslides__arrows--outside .vueperslides__arrow--next {
  left: auto;
  right: -4.5em!important;
}
.vueperslides--rtl .vueperslides__arrows--outside .vueperslides__arrow--next, .vueperslides__arrows--outside .vueperslides__arrow--prev {
  right: auto;
  left: -4.5em!important;
}
::v-deep .vueperslides__parallax-wrapper {
  padding-bottom: 45%!important;
}
::v-deep .carousel-3d-slide {
  border-radius: 6px!important;
}
a.playerProfile:hover {
  text-decoration: none;
}
::v-deep a.prev {
  background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/alpstourgolf/2024/11/Left-Arrow.png);
  height: 66px !important;
  width: 70px !important;
  z-index: 9999;
  /* position: relative; */
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  top: 14px;
  left: -6px;
}
::v-deep a.next {
  background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/alpstourgolf/2024/11/Right-Arrow.png);
  height: 66px !important;
  width: 70px !important;
  z-index: 9999;
  /* position: relative; */
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  top: 14px;
  right: -5px;
}
::v-deep a.next > span{
  display: none;
}
::v-deep a.prev > span{
  display: none;
}
.lineBreakLine {
  margin-top: 10px;
}
.oomSliderPad {
  padding-left: 40px;
  padding-right: 40px;
  background-color: #fff;
  height: 400px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
span.oomSliderDetails {
  color: #152229;
  font-size: 20px;
  font-weight: 600;
  float: right;
}
span.oomSliderTitle {
  color: #152229;
  font-size: 16px;
  font-weight: 600;
}
.posPosition {
  position: relative;
  top: 30px;
}
.posCenter {
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  width: 90px;
  margin: auto;
  /* background-color: #C8102E; */
  background: url(https://ams3.digitaloceanspaces.com/ocs-sport/mena/2026/01/Ellipse-3-2.png);
  background-repeat: no-repeat;
  height: 90px;
  border-radius: 50px;
  position: relative;
  top: -1.8em;
  background-size: contain;
}
.slideName {
  color: #C8102E;
  font-size: 26px;
  text-align: center;
  font-weight: bold;
  /* margin-top: -0.8em; */
  margin-top: -18px;
  margin-bottom: 30px;
}
.oomImage {
  background-repeat: no-repeat;
  background-size: cover;
  height: 250px;
  /* background-position: center; */
  background-position: top;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
::v-deep .carousel-3d-container {
  height: 625px !important;
}
::v-deep .carousel-3d-slide {
  position: absolute;
  opacity: 0;
  visibility: hidden;
  overflow: hidden;
  top: 0;
  border-radius: 50px;
  /* border-color: #000; */
  /* border-color: rgba(0, 0, 0, .4); */
  border-style: solid;
  background-size: cover;
  background-color: #fff;
  display: block;
  margin: 0;
  box-sizing: border-box;
  text-align: left;
  height: 625px !important;
  border: 1px solid #e9e9e9;
}
.TitleArea {
  padding-bottom: 30px;
}
.paddingSpace {
  padding: 50px;
}
.Allbuttons {
  float: right;
  width: 244px;
  height: 50px;
  background: transparent;
  color: #152229;
  font-weight: 500;
  border-radius: 30px;
  border: 1px solid #C8102E;
  font-size: 16px;
  transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
}
.Allbuttons:hover {
  float: right;
  width: 244px;
  height: 50px;
  background: #C8102E;
  color: #fff;
  font-weight: 500;
  border-radius: 30px;
  border: 1px solid #E8E8E8;
  transform: translateY(-10px);
}
h1.heading.extraPad {
  /* padding: 20px; */
}
.heading{
  font-weight: 600;
  font-size: 40px;
  color: #C8102E;
}
::v-deep tbody {
  font-size: 1rem;
}
a {
  color: #337ab7!important;
  background-color: transparent;
  font-weight: 500;
}
a:hover{
  text-decoration: underline;
}
::v-deep td.posnum {
  padding: 5px;
  background-color: #C8102E;
  color: #ffffff;
  padding-top: 4px;
  padding-bottom: 4px;
  display: block;
  max-width: 58px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 2px;
  margin-bottom: 0px;
  text-align: center;
}
::v-deep thead {
  color: white; 
}

::v-deep th {
  width: 15%;
  text-align: left;
  background-color: #C8102E!important;
  font-weight: 400;
}

::v-deep td {
  text-align: left;
  padding-top: 6px!important;
  padding-bottom: 6px!important;
  font-size: 1rem;
}
::v-deep th:first-child{
  text-align: center;
}
.flag {
  width: 30px;
  box-shadow: 0 0 3px #555;
}
::v-deep tr:nth-child(odd) {
  background-color: #dfe1e6;
}
.table{
      margin-bottom: 0;
}
.more{
  background-color: #dfe1e6;
  text-align: center;
}
::v-deep td{
  border-top: 0!important;
}
.flex{
  display: inline-flex;
}
.moreBtn{
  color: #337ab7 !important;
  font-size: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  background: #dfe1e6!important;
  border: none!important;
  box-shadow: none!important;
  padding: 0.375rem 0.175rem;
}
.fullList{
  width: auto!important;
}
.fullList>a{
  color: #337ab7 !important;
  font-size: 20px;
  font-weight: 400;
  text-decoration: none;
}
li {
  list-style: none;
}
.black{
  color: black;
  margin-left: -10px;
}


@media only screen and (max-width: 990px) {
  .carousel-3d-slide.current {
    width: 100%!important;
  }
  .Allbuttons {
    float: none;
    width: 244px;
    height: 50px;
    background: transparent;
    color: #152229;
    font-weight: 500;
    border-radius: 30px;
    border: 1px solid #C8102E;
    display: block;
    margin: auto;
    margin-top: 30px;
    transition: all 0.4s ease;
    /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
    transition: all 350ms cubic-bezier(.37, 0, .63, 1);
  }
  .Allbuttons:hover {
    float: none;
    width: 244px;
    height: 50px;
    background: #C8102E;
    color: #fff;
    font-weight: 500;
    border-radius: 30px;
    border: 1px solid #E8E8E8;
    transform: translateY(-10px);
  }
  .heading {
    font-weight: 600;
    font-size: 40px;
    color: #C8102E;
    text-align: center;
    padding-top: 30px;
  }
   .paddingSpace {
    padding: 15px;    
  }
  ::v-deep .carousel-3d-slider {
    width: auto!important;
  }
}
@media only screen and (max-width: 768px) {

  ::v-deep th {
    font-size: 13px !important;
  }
  ::v-deep td {
    font-size: 13px !important;
  }
  .fullList>a{
    font-size: 12px!important;
    padding-left: 0.7rem;
  }.moreBtn{
    font-size: 12px!important;
  }
  ::v-deep th:nth-child(3){
    display: none;
  }
  ::v-deep td:nth-child(3){
    display: none;
  }
}
@media only screen and (min-width: 769px) {
  .below769 {
    display: none;
  }
}
@media only screen and (max-width: 769px) {
  .above769 {
    display: none;
  }
  ::v-deep .vueperslides__parallax-wrapper
  {
      padding-bottom: 214% !important;
  }
}
@media only screen and (max-width: 510px) {
  ::v-deep .vueperslides__parallax-wrapper
  {
      padding-bottom: 183% !important;
  }
}
@media only screen and (max-width: 410px) {
  ::v-deep .vueperslides__parallax-wrapper
  {
      padding-bottom: 214% !important;
  }
}
</style>
